import { Injectable } from '@angular/core';
import { getFirebaseBackend } from '../../firebaseBackend/firestoreUtils';
import { AuthorityService } from './authority.service';
import { LogsService } from './logs.service';
import { UserService } from './user.service';
import { CompanyService } from './company.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  private moduleName = 'projects';

  constructor(private AuthorityService: AuthorityService,private logsService: LogsService,private userService:UserService, private CompanyService: CompanyService) { }
  /**
    * create project
    */
  createProject(project: any) {
    var AuthUser = getFirebaseBackend().getAuthenticatedUser();
    const docPathUser = `users/${AuthUser.uid}`;
    const collectionPathProject = `projects`;
    return getFirebaseBackend().createNewDocumentByCollectionPath(collectionPathProject, project).then((Project: any) => {
      var projectID = Project.id;
      getFirebaseBackend().getDocumentByDocPath(docPathUser).then((user: any) => {
        var userProjectRole;
        userProjectRole={
          projects:{
            [projectID]:{
              name:project.name,
              role:"owner"
            },
            ...user.projects
          } 
        }
        getFirebaseBackend().editDocumentByDocPath(docPathUser, userProjectRole);
      })
      //console.log("gyfugfeyiuiouowo", Project.id);
      return Project.id;
    })
  }
  /**
   * get all user project
   */
  getUserProjects() {
    const AuthUser = getFirebaseBackend().getAuthenticatedUser();
    const docPathUser = `users/${AuthUser.uid}`;
    return getFirebaseBackend().getDocumentByDocPath(docPathUser).then(async(user: any) => {
      let index: number = 0;
      const projects = [];
      for (const pid in user.projects) {
        index += 1;
        const project = await this.getProjectData(pid);
        const companyId = project['company_id'];
        const company = await this.CompanyService.getCompanyData(companyId);
        const data = {
          image: 'assets/images/companies/img-' + (index%6 !==0 ? index%6 : 6 ) + '.png',
          name: project.name,
          company: company.companyName,
          id: pid
        };
        projects.push(data);
      }
      projects.sort(function(a:any,b:any){
        if(a.name > b.name){
          return 1;
        }
        if(a.name < b.name){
          return -1;
        }
        return 0;
      })
      return projects;
    })
  }
  getUserProjectsWithUpdates(cb){
    let AuthUser = getFirebaseBackend().getAuthenticatedUser();
    const docPathUser = `users/${AuthUser.uid}`;
    getFirebaseBackend().getDocumentWithListener(docPathUser,(user: any,err) => {
      const userProjects = user.projects;
      const orderdProjects = [];
      let index: number = 0;
      for (const pid in user.projects) {
        index += 1;
        const data = {
          image: 'assets/images/companies/img-' + (index%6 !==0 ? index%6 : 6 ) + '.png',
          name: userProjects[pid].name,
          id: pid
        };
        orderdProjects.push(data);
      }
      orderdProjects.sort(function(a:any,b:any){
        if(a.name > b.name){
          return 1;
        }
        if(a.name < b.name){
          return -1;
        }
        return 0;
      })
      cb(orderdProjects);
    })
  }
  /**
    * get a project data
    */
  getProjectData(pid: string) {
    const docPath = `projects/${pid}`;
    return getFirebaseBackend().getDocumentByDocPath(docPath).then((project: any) => {
      return project;
    })
  }
  getProjectDataWithUpdate(pid: string,cb) {
    const docPath = `projects/${pid}`;
    return getFirebaseBackend().getDocumentWithListener(docPath,(res) => {
      cb(res)
    })
  }
  getProjectMembers(pid: string) {
    var usersRecords = []
    return this.getProjectData(pid).then((project: any) => {
      project.users.forEach(uid => {
        getFirebaseBackend().getDocumentByDocPath(`users/${uid}`).then((user:any)=>{
          var userRecord={
            uid:uid,
            name:user.firstName+" "+user.lastName,
            email:user.email,
            role:user.projects[pid].role
          }
          usersRecords.push(userRecord);
        }) 
      });
      // console.log("usersRole", usersRecords);
      return usersRecords;
    })
  }
  ////////////////////////////
  getUserByEmail(email:string){
    return getFirebaseBackend().getDocByUniqueProperty("users","email",email).then((res)=>{
       return res
    })
  }
  ///////////////////////////
  addMemberToProject(uid:string,pid:string,role:string){
    return this.getProjectData(pid).then((project: any) => {
      var users=project.users;
      users.push(uid);
      const docPathProject = `projects/${pid}`;
      getFirebaseBackend().editDocumentByDocPath(docPathProject,{users:users}).then(()=>{
        this.userService.getUserDataWithID(uid).then((userData:any)=>{
          this.logsService.sendLogRequest(pid,{
            log_generated_ts: new Date().getTime(),
            module: this.moduleName,
            action: "admin_added",
            data: JSON.stringify({
              admin_email: userData.email
            })
          })
        })
      })
      this.addProjectToMember(uid,pid,project.name,role);
      return true;
    })
  }
  addProjectToMember(uid:string,pid:string,Pname:string,role:string){
    const docPathUser = `users/${uid}`;
    getFirebaseBackend().getDocumentByDocPath(docPathUser).then((user: any) => {
      // console.log(user.projects)
        var userProjectRole;
        userProjectRole={
          projects:{
            [pid]:{
              name:Pname,
              role:role
            },
            ...user.projects
          } 
        }
        getFirebaseBackend().editDocumentByDocPath(docPathUser, userProjectRole);
    })
  }
  checkEmail(email){
    return getFirebaseBackend().getDocByUniqueProperty("users","email",email).then((doc)=>{
      // console.log(email)
      if(doc){
        return doc;
      }
    })
  }

  getProjectWithListener(pid,cb){
    const docPathProject = `projects/${pid}`;
    return getFirebaseBackend().getDocumentWithListener(docPathProject,cb);
  }

  updateProjectNotificationEmail(pid:string, notificationEmail:string){
    const docPathProject = `projects/${pid}`;
    return getFirebaseBackend().editDocumentByDocPath(docPathProject,{'billing.notifications_email': notificationEmail}).then((res:any)=>{
      return res;
    })
  }

}
